import React from "react";

const RI = () => {
  return (
    <div className="RI">
      <div class="border-indigo-500 text-white bg-gradient-to-r from-blue-100 via-blue-500 to-blue-100 mt-8">
        <div class="pt-6 md:p-0 text-center md:text-center text-blue  -space-y-4">
          <p class="text-4xl p-5"> Research Interests </p>
        </div>
      </div>
      <figure class="flex  items-center justify-center p-8">
        <div class="box-content items-center justify-center h-30 w-11/12 p-4 border-transparent bg-blue-50 hover:shadow-lg hover:border-transparent ">
          <div class="h-full w-full border-2 bg-blue-50 over:bg-white hover:shadow-lg hover:border-transparent hover:bg-white">
            <br></br>
            <ul class="list-disc text-sm sm:text-lg md:text-2xl text-left p-2">
              <li>Control Systems</li>
              <li>Machine Learning</li>
              <li>Embedded Systems</li>
              <li>Mechatronics modelling</li>
              <li>Image processing</li>
            </ul>
            <br></br>
          </div>
        </div>
      </figure>
    </div>
  );
};

export default RI;
